// locationsData.js - SEO & Location Landing Page Content Engine

export const locationsData = {

  /* ─────────────────────────────────────────────────
   * NEW HIGH-PRIORITY ENTRIES: Vendor / Supplier / Company keywords
   * These match the exact searches being done in Baddi right now
   * ───────────────────────────────────────────────── */

  "hvac-vendor-baddi-himachal": {
    slug: "hvac-vendor-baddi-himachal",
    cityName: "Baddi",
    stateName: "Himachal Pradesh",
    regionTitle: "Baddi Industrial Area, Solan, Himachal Pradesh",
    metaTitle: "HVAC Vendor in Baddi Himachal Pradesh | CoolRite Engineers",
    metaDescription: "Top HVAC vendor in Baddi, Himachal Pradesh. CoolRite Engineers supplies industrial HVAC systems, AC ducting, AHU units, VRF systems & MEP equipment. Call +91-7009167480.",
    keywords: "HVAC vendor Baddi, HVAC vendor Himachal Pradesh, HVAC supplier Baddi, HVAC company Baddi, industrial HVAC vendor Baddi, AC vendor Baddi",
    heroHeading: "Trusted HVAC Vendor & Supplier in Baddi, Himachal Pradesh",
    heroSubheading: "CoolRite Engineers — Your Reliable HVAC Vendor for Industrial & Commercial AC Systems, Ducting, AHU, VRF & MEP Equipment Supply across Baddi, Nalagarh & Solan.",
    highlights: [
      "HVAC Equipment Supply & Turnkey Installation in Baddi Industrial Zone",
      "Authorized Vendor for Pharma, Manufacturing & Chemical Plants",
      "GI Sheet Ducting, AHU, Chiller & VRF System Supply & Installation",
      "Quick Delivery & Site Survey within 24 Hours in Baddi Area",
      "AMC Contracts, Spare Parts & Emergency Maintenance Support"
    ],
    industrialAreasCovered: [
      "Baddi Phase 1 & Phase 2",
      "Jharmajri EPIP Zone",
      "Barotiwala Industrial Estate",
      "Nalagarh Industrial Corridor",
      "Kala Amb & Parwanoo",
      "Bhud, Solan & Swarghat Road"
    ],
    servicesOffered: [
      {
        name: "HVAC System Supply & Installation",
        description: "Complete supply of split ACs, cassette units, ductable ACs, VRF/VRV systems, chillers and AHUs for factories and commercial buildings."
      },
      {
        name: "Industrial Ducting Supply (GI & PI)",
        description: "Manufacturer & vendor for rectangular and spiral GI sheet ducting with thermal insulation for Baddi industrial units."
      },
      {
        name: "AHU & Ventilation Equipment",
        description: "Supply and installation of double-skin Air Handling Units, fresh air systems, exhaust fans and HEPA filtration setups."
      },
      {
        name: "MEP Equipment & Contracting",
        description: "Turnkey Mechanical, Electrical, Plumbing and Fire Fighting system supply and installation across Baddi industrial zones."
      }
    ],
    faqs: [
      {
        question: "Is CoolRite Engineers a verified HVAC vendor in Baddi?",
        answer: "Yes. CoolRite Engineers is a verified and experienced HVAC vendor based in Bhud, Baddi, Solan, Himachal Pradesh. We supply and install industrial HVAC systems, AC ducting, AHU units, and MEP equipment for pharma companies, factories and commercial buildings across Baddi and the surrounding area."
      },
      {
        question: "What HVAC products do you supply in Baddi?",
        answer: "We supply GI sheet ducting, pre-insulated (PI) ducts, Air Handling Units (AHU), VRF/VRV multi-zone systems, chiller plants, cassette ACs, ductable ACs, fresh air systems, exhaust units, and fire fighting systems."
      },
      {
        question: "How quickly can you visit our factory in Baddi?",
        answer: "Our local engineering team in Bhud, Baddi can visit your site for a free survey within 24 hours and provide a detailed BOQ estimate."
      }
    ]
  },

  "hvac-supplier-baddi-himachal": {
    slug: "hvac-supplier-baddi-himachal",
    cityName: "Baddi",
    stateName: "Himachal Pradesh",
    regionTitle: "Baddi, Nalagarh & Barotiwala, Himachal Pradesh",
    metaTitle: "HVAC Supplier in Baddi Himachal Pradesh | CoolRite Engineers",
    metaDescription: "Best HVAC supplier in Baddi, HP. CoolRite Engineers supplies AHU, VRF, chiller, GI ducting, and MEP systems for pharma, chemical and industrial plants. Get BOQ estimate.",
    keywords: "HVAC supplier Baddi, HVAC company Baddi Himachal, AC supplier Baddi, ducting supplier Baddi, AHU supplier Baddi HP, industrial ventilation supplier Baddi",
    heroHeading: "Leading HVAC Supplier in Baddi, Nalagarh & Barotiwala",
    heroSubheading: "Complete HVAC Supply Chain Partner for Industrial, Commercial & Pharmaceutical Plants in Himachal Pradesh. GI Ducting, AHU, VRF & MEP Systems.",
    highlights: [
      "Specialist HVAC Supplier for Pharmaceutical GMP Plants in Baddi",
      "GI Duct Fabrication Workshop Near Baddi for Fast Lead Times",
      "Supply of Branded & Custom-Made HVAC & Ventilation Equipment",
      "Competitive Pricing with Transparent BOQ Documentation",
      "Post-Supply Installation, Testing & Commissioning Support"
    ],
    industrialAreasCovered: [
      "Baddi Industrial Area",
      "Jharmajri",
      "Barotiwala",
      "Nalagarh",
      "Kala Amb",
      "Solan & Parwanoo"
    ],
    servicesOffered: [
      {
        name: "GI & PI Ducting Supply",
        description: "Custom fabricated galvanized iron and pre-insulated duct supply for pharma and industrial HVAC systems."
      },
      {
        name: "AHU & FCU Supply",
        description: "Single and double-skin AHU supply with HEPA filtration, VFD drives, and chilled water coils."
      },
      {
        name: "VRF / VRV System Supply",
        description: "Multi-zone inverter-based VRF system supply and installation for office buildings, hospitals and commercial spaces."
      },
      {
        name: "Chiller Plant Supply",
        description: "Air-cooled and water-cooled chiller plant supply and installation for large industrial and commercial facilities."
      }
    ],
    faqs: [
      {
        question: "Are you a registered HVAC supplier in Baddi Himachal Pradesh?",
        answer: "Yes, CoolRite Engineers is a registered and verified HVAC and MEP equipment supplier based at Bhud, Baddi, Solan (HP - 173205). We serve the entire Baddi-Nalagarh-Barotiwala industrial corridor."
      }
    ]
  },

  "hvac-company-baddi-himachal": {
    slug: "hvac-company-baddi-himachal",
    cityName: "Baddi",
    stateName: "Himachal Pradesh",
    regionTitle: "Baddi & Solan District, Himachal Pradesh",
    metaTitle: "Best HVAC Company in Baddi Himachal Pradesh | CoolRite Engineers",
    metaDescription: "CoolRite Engineers — the best HVAC company in Baddi, Himachal Pradesh. 10+ years of industrial HVAC, cleanroom ventilation, AC ducting, AHU, and MEP project experience.",
    keywords: "HVAC company Baddi, best HVAC company Himachal Pradesh, HVAC contractor Baddi HP, HVAC firm Baddi, top HVAC company Solan, industrial HVAC company Baddi",
    heroHeading: "Best HVAC Company in Baddi, Himachal Pradesh",
    heroSubheading: "10+ Years of Trusted HVAC Engineering Across Baddi's Pharma, Manufacturing & Industrial Sectors. Full-Service MEP Contracting, Ducting, AHU & VRF Specialists.",
    highlights: [
      "10+ Years of HVAC Experience in Baddi's Pharma & Industrial Zone",
      "Turnkey Design, Supply & Installation under One Roof",
      "Worked with Cipla, Panacea Biotec, Ind-Swift Labs & More",
      "GMP & ISO Compliant Cleanroom HVAC Engineering",
      "Local Office at Bhud, Baddi – Fast Response Guaranteed"
    ],
    industrialAreasCovered: [
      "Baddi Phase 1, Phase 2 & Jharmajri",
      "Barotiwala Industrial Estate",
      "Nalagarh Industrial Belt",
      "Kala Amb Chemical & Pharma Zone",
      "Parwanoo & Solan Commercial Areas"
    ],
    servicesOffered: [
      {
        name: "Pharma Cleanroom HVAC Design & Installation",
        description: "GMP-compliant clean room HVAC systems with precise temperature, humidity, and differential pressure controls for pharmaceutical plants in Baddi."
      },
      {
        name: "Industrial Ventilation & Ducting",
        description: "Exhaust, supply, return air and dust extraction ducting systems for manufacturing and chemical plants."
      },
      {
        name: "Complete MEP Turnkey Projects",
        description: "End-to-end Mechanical, Electrical, Plumbing, and Fire Fighting system design and installation."
      }
    ],
    faqs: [
      {
        question: "Why is CoolRite Engineers the best HVAC company in Baddi?",
        answer: "CoolRite Engineers has 10+ years of local experience working with top pharmaceutical companies like Cipla, Panacea Biotec, and Ind-Swift Labs in Baddi. We offer turnkey design, supply, fabrication, and installation from our local office in Bhud, Baddi."
      }
    ]
  },

  "hvac-contractors-baddi-himachal": {
    slug: "hvac-contractors-baddi-himachal",
    cityName: "Baddi",
    stateName: "Himachal Pradesh",
    regionTitle: "Baddi & Nalagarh Industrial Belt, Solan (HP)",
    metaTitle: "HVAC Contractors in Baddi Himachal Pradesh | CoolRite Engineers",
    metaDescription: "Leading HVAC contractors in Baddi, Himachal Pradesh. Specialized in pharma cleanroom HVAC, industrial AC ducting, AHU, VRF, and MEP services. Contact CoolRite Engineers today!",
    keywords: "HVAC contractors in Baddi, industrial HVAC Baddi Himachal, AC ducting Baddi, pharma cleanroom HVAC Baddi, AHU suppliers Baddi, MEP contractors Solan HP",
    heroHeading: "Leading Industrial HVAC Contractors in Baddi, Himachal Pradesh",
    heroSubheading: "Turnkey HVAC, Pharma Cleanroom Ventilation, Ducting, AHU & MEP Engineering Solutions for Factories & Industrial Units across Baddi, Barotiwala, & Nalagarh.",
    
    highlights: [
      "Specialized in GMP & ISO Compliant Cleanroom HVAC for Pharma Manufacturing",
      "Over 10+ Years of Industrial Ducting & Chiller Plant Experience in HP",
      "Complete Load Calculation, Fabrication, Testing & Commissioning",
      "Local Engineering Team based near Baddi Industrial Area",
      "24/7 Emergency Maintenance & Preventive AMC Contracts"
    ],

    industrialAreasCovered: [
      "Baddi Phase 1 & Phase 2",
      "Jharmajri Industrial Area",
      "Barotiwala Industrial Estate",
      "Nalagarh Industrial Corridor",
      "Kala Amb Industrial Area",
      "Parwanoo & Solan Sector"
    ],

    servicesOffered: [
      {
        name: "Pharma Cleanroom HVAC",
        description: "ISO Class 5 to Class 8 cleanroom air handling systems with HEPA filtration, differential pressure control, and precise temperature/humidity regulation."
      },
      {
        name: "Industrial GI & PI Ducting",
        description: "Precision engineered rectangular and spiral galvanised iron (GI) ducting fabrication and thermal insulation for factories."
      },
      {
        name: "Air Handling Units (AHU) & FCU",
        description: "Heavy-duty modular AHU installation, ductable units, air washers, and fresh air/exhaust systems."
      },
      {
        name: "Commercial Chiller & VRV/VRF Systems",
        description: "Energy-efficient air-cooled and water-cooled chiller plants and multi-zone VRF climate control."
      },
      {
        name: "MEP & Fire Fighting Integration",
        description: "Complete Mechanical, Electrical, Plumbing, and Fire Hydrant/Sprinkler systems for industrial approvals."
      }
    ],

    faqs: [
      {
        question: "Why is CoolRite Engineers the preferred HVAC contractor in Baddi?",
        answer: "CoolRite Engineers understands the strict technical requirements of Baddi's pharmaceutical and manufacturing hubs. We deliver custom-engineered HVAC designs compliant with USFDA, GMP, and NABH standards."
      },
      {
        question: "Do you offer turnkey MEP and HVAC contracts in Baddi & Nalagarh?",
        answer: "Yes, we provide end-to-end turnkey HVAC, ducting, electrical wiring, plumbing, and fire fighting solutions from design to final commissioning."
      },
      {
        question: "How quickly can your team visit industrial sites in Baddi?",
        answer: "We offer rapid response site surveys across Baddi, Jharmajri, Barotiwala, and Nalagarh within 24 to 48 hours."
      }
    ]
  },

  "industrial-ducting-baddi": {
    slug: "industrial-ducting-baddi",
    cityName: "Baddi",
    stateName: "Himachal Pradesh",
    regionTitle: "Baddi & Solan Industrial Region",
    metaTitle: "Industrial AC Ducting & Insulation Services Baddi | CoolRite Engineers",
    metaDescription: "Top-grade industrial AC ducting manufacturers and installation experts in Baddi. GI, PI, spiral ducting & duct insulation for pharma and factories.",
    keywords: "industrial ducting Baddi, AC ducting manufacturer Baddi, spiral ducting Himachal Pradesh, duct insulation Baddi, GI ducting fabrication Solan",
    heroHeading: "Industrial AC Ducting & Ventilation Experts in Baddi",
    heroSubheading: "Precision Rectangular, Spiral & Pre-Insulated (PI) Duct Fabrication, Installation & Thermal Insulation for Baddi Factories.",
    
    highlights: [
      "Custom Factory Fabrication for Minimum Air Resistance & Zero Leakage",
      "High-Grade Galvanized Iron (GI) & Pre-Insulated Duct Systems",
      "Acoustic & Nitrile Rubber / Glasswool Insulation Standards",
      "Air Balancing & Airflow Measurement Certification",
      "Turnkey Duct Setup for HVAC, Cleanrooms & Exhaust Plants"
    ],

    industrialAreasCovered: [
      "Baddi Industrial Area",
      "Jharmajri EPIP Zone",
      "Barotiwala Factory Belt",
      "Nalagarh Industrial Hub",
      "Kala Amb & Parwanoo"
    ],

    servicesOffered: [
      {
        name: "Rectangular GI Sheet Ducting",
        description: "Heavy-gauge galvanized iron ducting built to SMACNA specifications for high durability and optimal air volume."
      },
      {
        name: "Spiral Circular Ducting",
        description: "Aesthetically pleasing, low friction spiral ducts ideal for exposed ceilings, cleanrooms, and high-velocity systems."
      },
      {
        name: "Duct Thermal & Acoustic Insulation",
        description: "XLPE, Nitrile Rubber, and Fiberglass insulation preventing condensation and reducing system noise."
      },
      {
        name: "Industrial Dust & Fume Exhaust Ducting",
        description: "Heavy-duty exhaust duct systems designed to handle chemical fumes, dust particles, and heat extraction."
      }
    ],

    faqs: [
      {
        question: "What sheet thickness do you use for industrial ducting in Baddi?",
        answer: "We use high-grade GI sheets ranging from 24G to 18G depending on duct size, pressure classification, and SMACNA/IS standards."
      },
      {
        question: "Do you supply pre-insulated (PI) ducting for pharma plants?",
        answer: "Yes, we manufacture and install lightweight, antimicrobial PI duct systems ideal for cleanroom applications."
      }
    ]
  },

  "ahu-ventilation-system-baddi": {
    slug: "ahu-ventilation-system-baddi",
    cityName: "Baddi",
    stateName: "Himachal Pradesh",
    regionTitle: "Baddi & Himachal Pradesh",
    metaTitle: "AHU & Industrial Ventilation Systems in Baddi | CoolRite Engineers",
    metaDescription: "Professional Air Handling Unit (AHU) installation, cleanroom ventilation, and air washer systems in Baddi, Himachal Pradesh by CoolRite Engineers.",
    keywords: "AHU installation Baddi, Air Handling Unit Baddi, industrial ventilation Baddi HP, fresh air system Baddi, cleanroom AHU manufacturer Solan",
    heroHeading: "Air Handling Unit (AHU) & Ventilation Systems in Baddi",
    heroSubheading: "State-of-the-Art AHU Units, Fresh Air Supply, Exhaust Systems & Cleanroom Air Quality Control for Baddi Industries.",
    
    highlights: [
      "Double-Skin Thermal Break AHUs for Optimum Energy Savings",
      "HEPA, EU4, EU7 & EU9 Multi-Stage Air Filtration Systems",
      "Air Washers, Evaporative Cooling & Scrubbers",
      "Variable Frequency Drive (VFD) Smart Airflow Control",
      "Turnkey Installation & Servicing in Baddi Industrial Zone"
    ],

    industrialAreasCovered: [
      "Baddi Industrial Belt",
      "Nalagarh Textile & Pharma Zone",
      "Barotiwala Industrial Area",
      "Kala Amb Chemical & Steel Sector"
    ],

    servicesOffered: [
      {
        name: "Double-Skin Cleanroom AHU",
        description: "Antibacterial double-skin panels with PUF insulation preventing heat loss and biological contamination."
      },
      {
        name: "Industrial Fresh Air & Exhaust Systems",
        description: "Balanced ventilation systems supplying filtered outdoor air while purging stagnant air and airborne toxins."
      },
      {
        name: "Scrubber & Odor Control Systems",
        description: "Wet scrubbers and industrial air purification units for chemical processing plants in Baddi."
      }
    ],

    faqs: [
      {
        question: "How often should AHU filters be replaced in Baddi industrial units?",
        answer: "Pre-filters should be cleaned or replaced every 1 to 3 months, while HEPA filters typically last 12 to 24 months depending on dust load."
      }
    ]
  },

  "hvac-contractors-chandigarh-mohali": {
    slug: "hvac-contractors-chandigarh-mohali",
    cityName: "Chandigarh & Mohali",
    stateName: "Chandigarh / Punjab",
    regionTitle: "Tricity (Chandigarh, Mohali, Panchkula)",
    metaTitle: "HVAC & Ducting Contractors Chandigarh Mohali Panchkula | CoolRite",
    metaDescription: "Premier HVAC, ductable AC, VRV/VRF, and MEP contractors serving Chandigarh, Mohali, and Panchkula. Commercial & industrial turnkey solutions.",
    keywords: "HVAC contractors Chandigarh, AC ducting Mohali, VRF system installation Panchkula, commercial HVAC Tricity, MEP engineers Mohali",
    heroHeading: "Top Commercial & Industrial HVAC Contractors in Chandigarh, Mohali & Panchkula",
    heroSubheading: "Custom HVAC System Design, Centralized Air Conditioning, Ducting, VRV/VRF & MEP Contracting for Commercial Towers, IT Parks & Hospitals in Tricity.",
    
    highlights: [
      "Turnkey HVAC for IT Parks, Shopping Malls, Hotels & Hospitals in Mohali & Chandigarh",
      "VRV / VRF Energy Efficient Multi-Zone Climate Systems",
      "Ceiling Cassette & Concealed Ductable AC Installations",
      "Fire Fighting, Electrical & Plumbing MEP Contracting",
      "Prompt Local Service Team across Chandigarh, Mohali & Panchkula"
    ],

    industrialAreasCovered: [
      "Mohali IT City & Sector 67-82 Industrial Area",
      "Chandigarh Industrial Area Phase 1 & Phase 2",
      "Panchkula Industrial Area Phase 1 & 2",
      "Zirakpur Commercial Corridor",
      "Derabassi Industrial Belt"
    ],

    servicesOffered: [
      {
        name: "VRV / VRF Air Conditioning",
        description: "Smart inverter multi-split systems offering individualized climate control for modern IT offices and showrooms."
      },
      {
        name: "Commercial Ductable & Cassette Systems",
        description: "High-static concealed ductable units and 360-degree airflow cassette ACs for sleek interior integration."
      },
      {
        name: "Centralized Chiller Plants",
        description: "Water-cooled and air-cooled chiller installations for hospitals, hotels, and large commercial spaces in Tricity."
      }
    ],

    faqs: [
      {
        question: "Do you serve commercial offices in IT Park Mohali and Chandigarh?",
        answer: "Yes, we specialize in high-efficiency VRF and ductable AC installations for corporate IT offices, diagnostic centers, and retail spaces in Tricity."
      }
    ]
  },

  "industrial-hvac-mep-punjab": {
    slug: "industrial-hvac-mep-punjab",
    cityName: "Statewide",
    stateName: "Punjab",
    regionTitle: "Punjab Statewide Industrial Hubs",
    metaTitle: "Industrial HVAC & MEP Contractors in Punjab | CoolRite Engineers",
    metaDescription: "Leading industrial HVAC, Chiller plant, AHU, and MEP engineering contractors serving Ludhiana, Jalandhar, Amritsar, Patiala & Mandi Gobindgarh.",
    keywords: "HVAC contractors Punjab, industrial chiller plant Ludhiana, MEP contractor Punjab, factory ventilation Jalandhar, ducting manufacturer Patiala",
    heroHeading: "Statewide Industrial HVAC & MEP Contractors in Punjab",
    heroSubheading: "Heavy-Duty Chiller Plants, AHU Units, GI Ducting, Factory Ventilation & MEP Engineering for Manufacturing Plants across Punjab.",
    
    highlights: [
      "Turnkey HVAC Contracting for Textile, Steel, Engineering & Agro Industries in Punjab",
      "Centralized Water & Air Cooled Chiller Installation",
      "Heavy-Duty Industrial Exhaust & Dust Collection Ducting",
      "Full MEP Compliance (Fire Hydrants, Electrical Panels, Plumbing)",
      "Dedicated Project Managers for On-Time Execution across Punjab"
    ],

    industrialAreasCovered: [
      "Ludhiana Industrial Area & Focal Points",
      "Jalandhar Focal Point & Leather Complex",
      "Amritsar Industrial Zone",
      "Mandi Gobindgarh Steel Hub",
      "Patiala Industrial Estate",
      "Bathinda & Rajpura Corridor"
    ],

    servicesOffered: [
      {
        name: "Industrial Chiller Plants & Cooling Towers",
        description: "Centralized process cooling and HVAC chiller installations designed for continuous 24/7 factory operations."
      },
      {
        name: "Heavy Factory Ventilation & Exhaust",
        description: "High-volume air movement systems, forced draft ventilation, and dust collectors for metal, textile & agro plants."
      },
      {
        name: "Full MEP Project Contracting",
        description: "Integrated Mechanical, Electrical, Plumbing, and Fire Safety infrastructure for industrial approvals in Punjab."
      }
    ],

    faqs: [
      {
        question: "Do you handle industrial HVAC projects across all districts of Punjab?",
        answer: "Yes, our engineering team executes projects across Ludhiana, Jalandhar, Amritsar, Patiala, Mandi Gobindgarh, and all industrial corridors in Punjab."
      }
    ]
  },

  /* ═══════════════════════════════════════════════════════════════
   * CHANDIGARH / MOHALI / PANCHKULA — ALL KEYWORD VARIATIONS
   * Targets: contractor, vendor, supplier, company, services, installation
   * ═══════════════════════════════════════════════════════════════ */

  "hvac-contractor-chandigarh": {
    slug: "hvac-contractor-chandigarh",
    cityName: "Chandigarh",
    stateName: "Chandigarh / Punjab",
    regionTitle: "Chandigarh, Mohali & Panchkula (Tricity)",
    metaTitle: "HVAC Contractor in Chandigarh | CoolRite Engineers",
    metaDescription: "Top HVAC contractor in Chandigarh. CoolRite Engineers provides commercial AC ducting, VRF, AHU, chiller, and MEP services for IT parks, hospitals & offices in Chandigarh, Mohali & Panchkula.",
    keywords: "HVAC contractor Chandigarh, HVAC company Chandigarh, AC contractor Chandigarh, commercial HVAC Chandigarh, air conditioning contractor Chandigarh, MEP contractor Chandigarh",
    heroHeading: "Top HVAC Contractor in Chandigarh, Mohali & Panchkula",
    heroSubheading: "Commercial & Industrial HVAC Systems, AC Ducting, VRF/VRV, AHU Installation & MEP Contracting for IT Parks, Hospitals, Hotels & Offices in Tricity.",
    highlights: [
      "Commercial HVAC Specialist for IT Parks, Offices & Hospitals in Chandigarh",
      "VRF / VRV Multi-Zone Climate Control Systems",
      "Cassette & Concealed Ductable AC Installation",
      "Centralized Chiller Plants for Large Complexes",
      "Quick Site Survey & BOQ within 48 Hours in Tricity"
    ],
    industrialAreasCovered: [
      "Chandigarh Industrial Area Phase 1 & 2",
      "Mohali IT City & Sector 67–82",
      "Panchkula Industrial Area Phase 1 & 2",
      "Zirakpur & Derabassi Commercial Belt",
      "Dera Bassi & Kurali Industrial Zone"
    ],
    servicesOffered: [
      { name: "VRF / VRV System Installation", description: "Smart inverter multi-zone climate control for IT offices, showrooms and multi-floor buildings in Chandigarh." },
      { name: "Commercial Ductable & Cassette AC", description: "High-static concealed ductable ACs and 360-degree cassette units for sleek commercial interiors in Mohali." },
      { name: "Centralized Chiller Plants", description: "Water-cooled and air-cooled chiller installations for hospitals, hotels and large commercial complexes." },
      { name: "MEP & Fire Fighting Contracting", description: "Complete Mechanical, Electrical, Plumbing and Fire Safety systems for commercial buildings in Tricity." }
    ],
    faqs: [
      { question: "Do you serve IT parks and corporate offices in Chandigarh and Mohali?", answer: "Yes, CoolRite Engineers regularly handles VRF and ductable AC installations for corporate offices, IT parks, diagnostic centers, and retail showrooms across Chandigarh, Mohali, and Panchkula." },
      { question: "How soon can your team visit a site in Chandigarh?", answer: "We can arrange a site survey and provide a detailed BOQ for your Chandigarh or Mohali project within 24 to 48 hours of inquiry." }
    ]
  },

  "hvac-vendor-chandigarh": {
    slug: "hvac-vendor-chandigarh",
    cityName: "Chandigarh",
    stateName: "Chandigarh / Punjab",
    regionTitle: "Chandigarh, Mohali & Panchkula Tricity",
    metaTitle: "HVAC Vendor in Chandigarh Mohali Panchkula | CoolRite Engineers",
    metaDescription: "Reliable HVAC vendor in Chandigarh. CoolRite Engineers supplies VRF, AHU, chiller, GI ducting and MEP equipment for commercial and industrial projects across Tricity.",
    keywords: "HVAC vendor Chandigarh, HVAC vendor Mohali, HVAC supplier Chandigarh, AC vendor Chandigarh, ducting vendor Chandigarh, VRF supplier Chandigarh, MEP vendor Panchkula",
    heroHeading: "Trusted HVAC Vendor & Supplier in Chandigarh, Mohali & Panchkula",
    heroSubheading: "Complete HVAC Equipment Supply — VRF, AHU, Chiller Plants, GI Ducting & MEP Systems for Commercial, Institutional & Industrial Projects across Tricity.",
    highlights: [
      "HVAC Equipment Vendor for Chandigarh, Mohali & Panchkula",
      "VRF, AHU, Chiller, Cassette & Ductable AC Supply",
      "GI Sheet Duct Fabrication & Supply",
      "Transparent BOQ & Competitive Pricing",
      "Installation Support & AMC Contracts Available"
    ],
    industrialAreasCovered: [
      "Chandigarh IT Park & Commercial Sector",
      "Mohali Phase 7, 8 & 9 Commercial Zone",
      "Panchkula Sector 20 & 22 Industrial Area",
      "Zirakpur, Derabassi & Kharar",
      "Dera Bassi & Kurali Industrial Belt"
    ],
    servicesOffered: [
      { name: "VRF / VRV System Supply", description: "Multi-zone inverter-based VRF system supply from leading brands for offices and commercial buildings in Chandigarh." },
      { name: "AHU & FCU Equipment Supply", description: "Double-skin AHUs, fan coil units, fresh air handling units for hospitals, hotels and corporate offices in Mohali." },
      { name: "GI Ducting & Insulation Supply", description: "Factory-fabricated GI sheet ducting, spiral ducts and thermal insulation supply for commercial HVAC systems." }
    ],
    faqs: [
      { question: "Do you supply HVAC equipment in Mohali and Panchkula?", answer: "Yes, CoolRite Engineers supplies and installs VRF systems, AHUs, chiller plants, and GI ducting for commercial and industrial clients across Chandigarh, Mohali, Panchkula, Zirakpur, and Derabassi." }
    ]
  },

  "ac-ducting-services-mohali": {
    slug: "ac-ducting-services-mohali",
    cityName: "Mohali",
    stateName: "Punjab",
    regionTitle: "Mohali, Chandigarh & Panchkula",
    metaTitle: "AC Ducting Services in Mohali | CoolRite Engineers",
    metaDescription: "Professional AC ducting services in Mohali, Punjab. CoolRite Engineers provides GI duct fabrication, installation and thermal insulation for offices, IT parks and commercial spaces.",
    keywords: "AC ducting Mohali, ductable AC installation Mohali, GI ducting Mohali, HVAC ducting services Chandigarh, AC duct installation Panchkula, commercial ducting Mohali Punjab",
    heroHeading: "Professional AC Ducting Services in Mohali, Punjab",
    heroSubheading: "Expert GI Sheet Duct Fabrication, Installation & Thermal Insulation for IT Parks, Corporate Offices, Hospitals & Shopping Malls across Mohali, Chandigarh & Panchkula.",
    highlights: [
      "Precision GI & Spiral Duct Fabrication for Mohali Offices",
      "Acoustic Insulation for Noise-Sensitive IT & Hospital Environments",
      "Ductable Split AC & Central Air Handling System Installation",
      "Air Balancing & Commissioning Certification",
      "Annual Maintenance Contracts for Ducting Systems"
    ],
    industrialAreasCovered: [
      "Mohali Phase 1 to Phase 11",
      "IT City Chandigarh Technology Park",
      "Panchkula Sector 20 & 22",
      "Zirakpur Commercial Zone",
      "Kharar & Banur Industrial Area"
    ],
    servicesOffered: [
      { name: "GI Sheet Duct Fabrication & Installation", description: "Custom-built rectangular and spiral GI ducting systems for centralized air conditioning in offices and commercial spaces." },
      { name: "Pre-Insulated (PI) Duct Systems", description: "Lightweight antimicrobial PI duct systems for hygienic environments like hospitals, labs and clean offices in Mohali." },
      { name: "Ductable Split & Package AC Installation", description: "High-static ductable AC systems with full ducting network for large open-plan offices and retail spaces." }
    ],
    faqs: [
      { question: "Do you provide AC ducting installation for IT offices in Mohali?", answer: "Yes, we specialize in precision GI ducting, ductable split AC, and VRF system installations for IT parks, corporate offices and commercial complexes in Mohali, Chandigarh and Panchkula." }
    ]
  },

  /* ═══════════════════════════════════════════════════════════════
   * PUNJAB STATEWIDE — ALL KEYWORD VARIATIONS
   * Targets: contractor, vendor, supplier, services, installation
   * ═══════════════════════════════════════════════════════════════ */

  "hvac-contractor-punjab": {
    slug: "hvac-contractor-punjab",
    cityName: "Punjab",
    stateName: "Punjab",
    regionTitle: "Punjab Statewide — Ludhiana, Jalandhar, Amritsar, Patiala",
    metaTitle: "HVAC Contractor in Punjab | CoolRite Engineers",
    metaDescription: "Leading HVAC contractor in Punjab. CoolRite Engineers provides industrial chiller plants, AHU, ducting, VRF and MEP contracting for factories and commercial buildings across Punjab.",
    keywords: "HVAC contractor Punjab, industrial HVAC Punjab, HVAC company Punjab, AC contractor Punjab, HVAC services Punjab, MEP contractor Punjab, chiller plant Punjab",
    heroHeading: "Trusted Industrial HVAC Contractor Serving All of Punjab",
    heroSubheading: "Turnkey HVAC, Chiller Plants, AHU, GI Ducting, VRF Systems & MEP Engineering for Factories, Textile Units, Steel Plants & Commercial Buildings across Punjab.",
    highlights: [
      "Statewide HVAC Execution — Ludhiana, Jalandhar, Amritsar & Patiala",
      "Heavy Industrial Chiller Plant Installation & Commissioning",
      "Factory Exhaust & Dust Collection Ducting Systems",
      "VRF Multi-Zone Systems for Commercial Buildings",
      "Dedicated Project Managers for On-Time Punjab Delivery"
    ],
    industrialAreasCovered: [
      "Ludhiana Industrial Area & Focal Points",
      "Jalandhar Focal Point & Leather Complex",
      "Amritsar Industrial Zone",
      "Mandi Gobindgarh Steel Hub",
      "Patiala Industrial Estate",
      "Bathinda & Rajpura Industrial Corridor"
    ],
    servicesOffered: [
      { name: "Industrial Chiller Plant Installation", description: "Large-capacity air-cooled and water-cooled chiller plants for textile, steel, pharma and food processing factories across Punjab." },
      { name: "Factory Ventilation & Exhaust Ducting", description: "Heavy-duty exhaust systems, dust collectors and forced draft ventilation for Punjab manufacturing plants." },
      { name: "VRF & Commercial HVAC Systems", description: "VRF/VRV multi-zone systems and ductable ACs for corporate offices, malls and hospitals in Punjab cities." },
      { name: "Complete MEP Contracting", description: "Mechanical, Electrical, Plumbing and Fire Fighting infrastructure for industrial approvals across Punjab." }
    ],
    faqs: [
      { question: "Do you handle large HVAC projects across all of Punjab?", answer: "Yes, CoolRite Engineers executes industrial and commercial HVAC projects across all major Punjab cities including Ludhiana, Jalandhar, Amritsar, Patiala, Mandi Gobindgarh, and Bathinda." },
      { question: "Can you handle chiller plant installation for factories in Ludhiana?", answer: "Absolutely. We specialize in air-cooled and water-cooled chiller plant installations for textile, steel, engineering and agro-industrial factories across Ludhiana and all Punjab industrial zones." }
    ]
  },

  "hvac-vendor-punjab": {
    slug: "hvac-vendor-punjab",
    cityName: "Punjab",
    stateName: "Punjab",
    regionTitle: "Punjab — Ludhiana, Jalandhar, Amritsar, Patiala",
    metaTitle: "HVAC Vendor in Punjab | CoolRite Engineers",
    metaDescription: "Top HVAC vendor in Punjab. CoolRite Engineers supplies chiller plants, AHU, VRF systems, GI ducting and MEP equipment for industrial and commercial projects across Punjab.",
    keywords: "HVAC vendor Punjab, HVAC supplier Punjab, AC vendor Punjab, chiller vendor Punjab, AHU vendor Punjab, industrial HVAC vendor Ludhiana, ducting vendor Punjab",
    heroHeading: "Reliable HVAC Vendor & Supplier Serving Punjab",
    heroSubheading: "Industrial & Commercial HVAC Equipment Supply — Chillers, AHU, VRF, GI Ducting & MEP Systems for Factories and Offices across Punjab.",
    highlights: [
      "HVAC Equipment Supply for Textile, Steel & Pharma Industries in Punjab",
      "Chiller, AHU, VRF & GI Duct Supply with Fast Lead Times",
      "Competitive Pricing & Transparent BOQ Documentation",
      "Post-Supply Installation, Testing & Commissioning",
      "AMC Contracts & Spare Parts Support Across Punjab"
    ],
    industrialAreasCovered: [
      "Ludhiana Focal Point & Industrial Areas",
      "Jalandhar Focal Point",
      "Amritsar Industrial Zone",
      "Patiala & Mandi Gobindgarh",
      "Derabassi, Rajpura & Bathinda"
    ],
    servicesOffered: [
      { name: "Chiller Plant Supply & Installation", description: "Industrial chiller plant supply for textile mills, steel plants, pharma units and large commercial buildings in Punjab." },
      { name: "AHU & Ventilation Equipment Supply", description: "Air handling units, exhaust fans, fresh air units and HEPA filtration equipment supply for Punjab factories." },
      { name: "GI Ducting Supply & Fabrication", description: "Factory-fabricated GI sheet ducting supply for large industrial and commercial HVAC projects in Punjab." }
    ],
    faqs: [
      { question: "Are you a registered HVAC vendor in Punjab?", answer: "Yes, CoolRite Engineers is a registered HVAC and MEP equipment vendor serving industrial and commercial clients across all major Punjab cities including Ludhiana, Jalandhar, Amritsar, and Patiala." }
    ]
  },

  "mep-contractor-chandigarh-mohali": {
    slug: "mep-contractor-chandigarh-mohali",
    cityName: "Chandigarh & Mohali",
    stateName: "Punjab / Chandigarh",
    regionTitle: "Chandigarh, Mohali & Panchkula Tricity",
    metaTitle: "MEP Contractor in Chandigarh & Mohali | CoolRite Engineers",
    metaDescription: "Expert MEP contractor in Chandigarh and Mohali. CoolRite Engineers provides Mechanical, Electrical, Plumbing and Fire Fighting turnkey solutions for commercial and industrial projects.",
    keywords: "MEP contractor Chandigarh, MEP services Mohali, mechanical contractor Chandigarh, electrical plumbing contractor Mohali, fire fighting contractor Panchkula, MEP company Chandigarh",
    heroHeading: "Complete MEP Contractor for Chandigarh, Mohali & Panchkula",
    heroSubheading: "Turnkey Mechanical, Electrical, Plumbing & Fire Safety Engineering for Commercial Towers, IT Parks, Hospitals & Hotels across Tricity.",
    highlights: [
      "Full MEP Contracting Under One Roof for Tricity Projects",
      "HVAC + Electrical + Plumbing + Fire Fighting Integrated",
      "Compliance with NBC, IS & Local Municipal Regulations",
      "Experienced Project Engineers for Commercial Buildings",
      "On-Time Delivery with Minimal Disruption to Operations"
    ],
    industrialAreasCovered: [
      "Chandigarh Commercial & IT Sector",
      "Mohali Phase 8 & 9 Commercial Zone",
      "Panchkula Sector 20 Industrial Area",
      "Zirakpur & Derabassi",
      "Kharar & Ropar"
    ],
    servicesOffered: [
      { name: "HVAC & Mechanical Systems", description: "Complete HVAC design and installation including VRF, chillers, AHU and GI ducting for commercial buildings." },
      { name: "Electrical Panels & Wiring", description: "Complete LT electrical panel, cable routing, earthing and power distribution for commercial and industrial buildings." },
      { name: "Plumbing & Sanitation", description: "Water supply, drainage, hot water systems and sanitary fitting installation for commercial buildings in Tricity." },
      { name: "Fire Hydrant & Sprinkler Systems", description: "Fire safety infrastructure including hydrant mains, overhead tanks, sprinkler networks and alarm systems." }
    ],
    faqs: [
      { question: "Do you provide complete MEP contracting for commercial buildings in Chandigarh?", answer: "Yes, CoolRite Engineers provides comprehensive MEP contracting covering HVAC, Electrical, Plumbing and Fire Fighting systems for commercial towers, IT parks, hospitals and hotels in Chandigarh, Mohali and Panchkula." }
    ]
  }
};

